import React, { FunctionComponent, useRef, useState } from "react";
import { ButtonEnum } from "designSystem/types/button-types";
import { GridRow, GridRowProps } from "../grid/GridContainer";
import Button, { ButtonProps } from "./Button";
import { SaveButton } from "./ValidationButton";

export interface SaveCancelButtonsProps extends GridRowProps {
	/** design of the cancel button  */
	cancelButtonDesign?: ButtonProps["design"];

	/** callback function to cancel */
	onCancel: VoidFunction;

	/** callback function to save; return true to then call cancel callback */
	onSave: () => Promise<boolean>;

	/** callback function to validate before save; return true to continue to save, false to not save */
	onValidate?: () => Promise<boolean>;

	/** indicate whether or not disable the save button */
	saveButtonDisabled?: boolean;

	/** custom label for the save button (by using res mapping) */
	saveLabelRes?: string;

	/** custom label parameters for the save button (similar to resParams ) */
	saveLabelResParams?: string[];
}

const SaveCancelButtons: FunctionComponent<SaveCancelButtonsProps> = (props) => {
	const [saving, setSaving] = useState(false);
	const ref = useRef();

	const {
		cancelButtonDesign,
		saveButtonDisabled,
		saveLabelRes,
		saveLabelResParams,
		onCancel,
		onSave,
		onValidate,
		...otherProps
	} = props;

	async function onClickSave(): Promise<void> {
		setSaving(true);

		try {
			await onSave();
		} catch (ex) {

		} finally {
			// since this function is an async function, this component could be unmounted already, so double check to avoid memory leak
			if (ref.current) {
				setSaving(false);
			}
		}
	}

	return (
		<GridRow
			growAllChildren
			ref={ref}
			spacing={3}
			{...otherProps}
		>
			<SaveButton
				disabled={saveButtonDisabled}
				labelRes={saveLabelRes}
				onAction={onClickSave}
				onValidate={onValidate}
				resParams={saveLabelResParams}
			/>
			<Button
				design={cancelButtonDesign ?? "link"}
				disabled={saving}
				fullWidth
				onClick={onCancel}
				res={ButtonEnum.BUTTON_CANCEL}
			/>
		</GridRow>
	);
};

export default SaveCancelButtons;